import { CollectionModelFieldHeight } from '@ikegps/core-shared';

/** A field and the logic to join it to another field */
export interface FieldJoin {
	type: string;
	field: CollectionModelFieldHeight;
	joins(other: FieldJoin): boolean;
	getTitle(): string;
}

/** Two joins that match each other.
 *
 * This interface does not accept CollectionModelFields because Angular uses it.
 */
export class FieldJoinMatch {
	fieldJoins: FieldJoin[];

	constructor(...joins: FieldJoin[]) {
		this.fieldJoins = joins;
	}

	getJoin(subformInstanceID: string, fieldName: string): FieldJoin | null {
		for (const join of this.fieldJoins) {
			if (join.field.parent.instanceId === subformInstanceID && join.field.schema.id === fieldName) {
				return join;
			}
		}

		return undefined;
	}

	getOppositeJoin(subformInstanceID: string, fieldName: string): FieldJoin | null {
		const join = this.getJoin(subformInstanceID, fieldName);
		if (join == null) {
			return undefined;
		}

		return this.fieldJoins.find((fieldJoin) => fieldJoin !== join);
	}
}
